import { Option } from "./types";

export const getDefaultSelectedOption = (
    options: Option[],
    defaultSelected: any
): Option => {
    for (const option of options) {
        if (Array.isArray(option.value)) {
            const nestedSelected = getDefaultSelectedOption(
                option.value,
                defaultSelected
            );
            if (nestedSelected.value) return nestedSelected;
        } else if (defaultSelected === option.value) return option;
    }
    return {
        value: "",
        label: "",
    };
};

export const includesIgnoreCase = (str1: string, str2: string) =>
    str1.toLowerCase().includes(str2.toLowerCase());

export const getUpdatedOptions = (
    options: Option[],
    selected: Option,
    key: "selected" | "hovered" = "selected"
): Option[] =>
    options.map((option) => {
        if (Array.isArray(option.value)) {
            const value = getUpdatedOptions(option.value, selected, key);
            return {
                ...option,
                value,
                [key]:
                    option.label.toLowerCase() ===
                        selected.label.toLowerCase() ||
                    value.some((op) => op[key]),
            };
        }
        return {
            ...option,
            [key]:
                (Array.isArray(selected.value) &&
                    selected.label.toLowerCase() ===
                        option.label.toLowerCase()) ||
                selected.value === option.value,
        };
    });

export const filterOptions = (options: Option[], str: string): Option[] => {
    return options.filter((op) => {
        return includesIgnoreCase(op.label.toLowerCase(), str.toLowerCase());
    });
};

export const getNextOption = (selectedOption: Option, options: Option[]) => {
    const currIndex = options.findIndex(
        (op) => op.label.toLowerCase() === selectedOption.label.toLowerCase()
    );

    if (currIndex === -1) return options[0];

    let nextIndex = currIndex === options.length - 1 ? 0 : currIndex + 1;

    if (options[nextIndex].disabled) {
        nextIndex = nextIndex === options.length - 1 ? 0 : nextIndex + 1;
    }
    return options[nextIndex];
};

export const getPrevOption = (selectedOption: Option, options: Option[]) => {
    const currIndex = options.findIndex(
        (op) => op.label.toLowerCase() === selectedOption.label.toLowerCase()
    );

    if (currIndex === -1) return options[options.length - 1];

    let nextIndex = currIndex === 0 ? options.length - 1 : currIndex - 1;

    if (options[nextIndex].disabled) {
        nextIndex = nextIndex === 0 ? options.length - 1 : nextIndex - 1;
    }
    return options[nextIndex];
};
